import { SET_STRATEGIC_ACT } from "../constant";

const StrategicActReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_STRATEGIC_ACT:
            return {
                ...state,
                data: action.data
            }
        default:
            return state
    }
}

export default StrategicActReducer